// extracted by mini-css-extract-plugin
module.exports = {"row":"_5b10bb2305--row--DOpd4","row--hovered":"_5b10bb2305--row--hovered--grmv0"};